<template>
  <div>
    <div class="child-bg-image">
      <div class="bg-image-section" />
      <div class="content-section">
        <check-in-check-out-page />
      </div>
    </div>
  </div>
</template>

<script>
import CheckInCheckOutPage from '../Components/CheckInPage.vue';
    export default {
        name: 'CheckIn',
        components: {
            'check-in-check-out-page': CheckInCheckOutPage,
        },
    };
</script>

<style scoped>
.content-section {
  padding: 0 !important;
}
</style>
